import React, { Component } from 'react';
import Button from 'Components/Button';
import PropTypes from 'prop-types';
import './NumberedCheckbox.scss';

export default class NumberedCheckbox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentIndex: this.props.currentIndex,
      isSelected: false,
    };

    this.attachBindings();
  }

  componentDidMount(props) {
  }

  toggleCheckbox() {
    this.setState({
      isSelected: !this.state.isSelected,
    });
    const isSelectedCopy = !this.state.isSelected;
    const newSelectedPage = {
      pageId: this.props.page.pageId,
      pageContent: this.props.page.pageContent,
      isSelected: isSelectedCopy,
    };
    this.props.toggleSelectedPage(newSelectedPage);
  }

  attachBindings() {
    this.toggleCheckbox = this.toggleCheckbox.bind(this);
  }

  render() {
    let checkedClass = '';
    if (this.props.currentIndex !== -1) {
      checkedClass = this.props.checkboxSelected ? 'no-conversion-checked' : 'checked';
    } else {
      checkedClass = this.props.checkboxSelected ? 'no-conversion-unchecked' : 'unchecked';
    }

    const baseClass = this.props.currentIndex !== -1
    ? (this.props.checkboxSelected ? 'numbered-checkbox-wrapper-no-conversion no-conversion-checked' : 'numbered-checkbox-wrapper checked')
    : (this.props.checkboxSelected ? 'numbered-checkbox-wrapper-no-conversion unchecked' : 'numbered-checkbox-wrapper unchecked');

    return (
      <div className={baseClass}>
        <Button
          action={this.toggleCheckbox}
          category="image-checkbox"
          type="submit"
          extraClass={checkedClass}
        >
          {this.props.currentIndex !== -1 && this.props.currentIndex}
        </Button>
      </div>
    );
  }
}

NumberedCheckbox.propTypes = {
  currentIndex: PropTypes.number.isRequired,
  page: PropTypes.object.isRequired,
  toggleSelectedPage: PropTypes.func.isRequired,
  selectAllFlag: PropTypes.bool,
};

